module.exports = __webpack_public_path__ + "static/media/ajuda.be571cfb.svg";